import * as c from '../constants/CourseConstants'
import template from './template'


export const orgsByCourse = (state, action) => template(state, action, c, 'ORGS_BY_COURSE')
